/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export enum TabType {
  LOCATIONS = 'LOCATIONS',
  PEOPLE = 'PEOPLE',
  ASSETS = 'ASSETS',
  VEHICLES = 'VEHICLES'
}
